(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    initBeforeAfterSliders();
  });

  /**
   * Initialize all before-after sliders on the page
   */
  function initBeforeAfterSliders() {
    const containers = document.querySelectorAll('.before-after__container');

    containers.forEach(function (container) {
      const beforeImageWrapper = container.querySelector('.before-after__image-wrapper--before');
      const afterImageWrapper = container.querySelector('.before-after__image-wrapper--after');
      const slider = container.querySelector('.before-after__slider');

      // Check if the before and after images have src attributes (are loaded)
      const beforeImage = beforeImageWrapper?.querySelector('img');
      const afterImage = afterImageWrapper?.querySelector('img');

      const hasImages = beforeImage && afterImage && beforeImage.getAttribute('src') && afterImage.getAttribute('src');

      if (!beforeImageWrapper || !afterImageWrapper || !slider) {
        return;
      }

      let isDragging = false;
      let activeContainer = null;

      /**
       * Update the slider and clip-path positions
       * @param {number} clientX - The clientX position from mouse/touch event
       */
      function updateSliderPosition(clientX) {
        const rect = container.getBoundingClientRect();
        const position = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));

        // Update slider position
        slider.style.left = position + '%';

        // Apply clip-path to BOTH image wrappers
        // This ensures both the image AND label are clipped properly
        beforeImageWrapper.style.clipPath = `polygon(0 0, ${position}% 0, ${position}% 100%, 0 100%)`;
        afterImageWrapper.style.clipPath = `polygon(${position}% 0, 100% 0, 100% 100%, ${position}% 100%)`;
      }

      // Mouse event handlers
      slider.addEventListener('mousedown', function (e) {
        isDragging = true;
        activeContainer = container;
        e.preventDefault();
        e.stopPropagation(); // Prevent event from bubbling
        document.body.style.userSelect = 'none'; // Prevent text selection
      });

      document.addEventListener(
        'mousemove',
        function (e) {
          if (!isDragging || activeContainer !== container) return;
          updateSliderPosition(e.clientX);
          e.stopPropagation(); // Prevent event from affecting other elements
        },
        { capture: true }
      );

      document.addEventListener(
        'mouseup',
        function (e) {
          if (isDragging && activeContainer === container) {
            isDragging = false;
            activeContainer = null;
            document.body.style.userSelect = ''; // Re-enable text selection
            e.stopPropagation();
          }
        },
        { capture: true }
      );

      // Touch event handlers
      slider.addEventListener(
        'touchstart',
        function (e) {
          isDragging = true;
          activeContainer = container;
          e.preventDefault();
          e.stopPropagation();
        },
        { passive: false, capture: true }
      );

      document.addEventListener(
        'touchmove',
        function (e) {
          if (!isDragging || activeContainer !== container) return;
          updateSliderPosition(e.touches[0].clientX);
          e.preventDefault();
          e.stopPropagation();
        },
        { passive: false, capture: true }
      );

      document.addEventListener(
        'touchend',
        function (e) {
          if (activeContainer === container) {
            isDragging = false;
            activeContainer = null;
            e.stopPropagation();
          }
        },
        { capture: true }
      );

      // Click on container
      container.addEventListener(
        'click',
        function (e) {
          if (e.target === slider || slider.contains(e.target)) return;
          activeContainer = container;
          updateSliderPosition(e.clientX);
          activeContainer = null;
          e.stopPropagation();
        },
        { capture: true }
      );

      // Set initial position (50%)
      updateSliderPosition(container.getBoundingClientRect().left + container.getBoundingClientRect().width / 2);
    });
  }

  // Add a refresh mechanism when images are loaded
  document.addEventListener('DOMContentLoaded', function () {
    // Listen for image load events on the document
    document.addEventListener(
      'load',
      function (event) {
        // Check if the loaded element is an image inside a before-after container
        if (event.target.tagName === 'IMG' && event.target.closest('.before-after__container')) {
          // Re-initialize the sliders
          initBeforeAfterSliders();
        }
      },
      true
    );

    // Create an observer for changes in the DOM
    const observer = new MutationObserver(function (mutations) {
      let shouldRefresh = false;

      mutations.forEach(function (mutation) {
        // Check if images were added or if src attributes were changed
        if (mutation.type === 'childList' || (mutation.type === 'attributes' && mutation.attributeName === 'src')) {
          shouldRefresh = true;
        }
      });

      if (shouldRefresh) {
        initBeforeAfterSliders();
      }
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src'],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('section.bestsellers').forEach(function(section) {
    var container = section.querySelector('.bestsellers-container');
    var progressBar = section.querySelector('.bestsellers-progress-bar');
    var progressFill = section.querySelector('.bestsellers-progress-fill');

    if (!container || !progressBar || !progressFill) return;

    var isInteracting = false;

    function updateProgress(percentage) {
      percentage = Math.max(0, Math.min(percentage, 1));
      var maxScroll = container.scrollWidth - container.clientWidth;
      container.scrollLeft = maxScroll * percentage;
      var maxTranslate = progressBar.offsetWidth - progressFill.offsetWidth;
      progressFill.style.transform = 'translateX(' + (maxTranslate * percentage) + 'px)';
    }

    progressBar.addEventListener('mousedown', function(e) {
      isInteracting = true;
      var rect = progressBar.getBoundingClientRect();
      updateProgress((e.clientX - rect.left) / rect.width);
      document.addEventListener('mousemove', onMouseMove);
    });

    function onMouseMove(e) {
      if (!isInteracting) return;
      var rect = progressBar.getBoundingClientRect();
      updateProgress((e.clientX - rect.left) / rect.width);
    }

    document.addEventListener('mouseup', function() {
      if (isInteracting) {
        isInteracting = false;
        document.removeEventListener('mousemove', onMouseMove);
      }
    });

    progressBar.addEventListener('touchstart', function(e) {
      isInteracting = true;
      var rect = progressBar.getBoundingClientRect();
      updateProgress((e.touches[0].clientX - rect.left) / rect.width);
      e.preventDefault();
    }, { passive: false });

    progressBar.addEventListener('touchmove', function(e) {
      if (!isInteracting) return;
      var rect = progressBar.getBoundingClientRect();
      updateProgress((e.touches[0].clientX - rect.left) / rect.width);
      e.preventDefault();
    }, { passive: false });

    progressBar.addEventListener('touchend', function() { isInteracting = false; });
    progressBar.addEventListener('touchcancel', function() { isInteracting = false; });

    container.addEventListener('scroll', function() {
      if (isInteracting) return;
      var maxScroll = container.scrollWidth - container.clientWidth;
      var percentage = maxScroll > 0 ? container.scrollLeft / maxScroll : 0;
      var maxTranslate = progressBar.offsetWidth - progressFill.offsetWidth;
      progressFill.style.transform = 'translateX(' + (maxTranslate * percentage) + 'px)';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-hotpoint"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const hotpoints = document.querySelectorAll('.hotpoint');

    hotpoints.forEach((hotpoint) => {
      // Toggle preview on click
      hotpoint.addEventListener('click', function (e) {
        // Remove active class from all other hotpoints
        hotpoints.forEach((hp) => {
          if (hp !== this) {
            hp.classList.remove('active');
          }
        });

        this.classList.toggle('active');
        e.stopPropagation();
      });
    });

    // Close preview when clicking outside
    document.addEventListener('click', function (e) {
      hotpoints.forEach((hotpoint) => {
        if (!hotpoint.contains(e.target)) {
          hotpoint.classList.remove('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hotspots"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const hotspots = document.querySelectorAll('.product-hotspots__hotspot');
    const productTitle = document.getElementById('current-product-title');
    const productImage = document.getElementById('current-product-image');
    const productDescription = document.getElementById('current-product-description');
    const productLink = document.getElementById('current-product-link');
    const isMobile = window.innerWidth < 768;
    const visualization = document.querySelector('.product-hotspots__visualization');
    const roomImage = document.querySelector('.product-hotspots__room-image');

    // Function to update the product info panel (desktop only)
    function updateProductInfo(hotspot) {
      const title = hotspot.getAttribute('data-product-title');
      const image = hotspot.getAttribute('data-product-image');
      const description = hotspot.getAttribute('data-product-description');
      const url = hotspot.getAttribute('data-product-url');

      // Update the DOM elements
      productTitle.textContent = title;
      productImage.src = image;
      productImage.alt = title;
      productDescription.innerHTML = description;
      productLink.href = url;

      // Add active class to current hotspot
      hotspots.forEach((h) => h.classList.remove('is-active'));
      hotspot.classList.add('is-active');
    }

    // Function to close all mobile tooltips
    function closeAllMobileTooltips() {
      if (window.innerWidth < 768) {
        hotspots.forEach((h) => h.classList.remove('is-active'));
      }
    }

    // Add event listeners to hotspots
    hotspots.forEach((hotspot) => {
      // On tablet/desktop: show on hover
      hotspot.addEventListener('mouseenter', function () {
        if (window.innerWidth >= 768) {
          updateProductInfo(this);
        }
      });

      // On mobile: toggle active state for mobile tooltip
      hotspot.addEventListener('click', function (e) {
        if (window.innerWidth < 768) {
          // If clicking the same hotspot that's already active, close it
          if (this.classList.contains('is-active')) {
            this.classList.remove('is-active');
          } else {
            // For mobile, just toggle the active class for the tooltip
            hotspots.forEach((h) => {
              if (h !== this) h.classList.remove('is-active');
            });
            this.classList.add('is-active');
          }

          // Prevent default only if we're toggling, not navigating
          if (!e.target.closest('.product-hotspots__mobile-tooltip-link')) {
            e.preventDefault();
          }
        } else {
          // Desktop behavior
          updateProductInfo(this);
          e.preventDefault();
        }

        // Stop propagation to prevent the room image click handler from firing
        e.stopPropagation();
      });
    });

    // Close tooltips when clicking on the room image (but not on hotspots)
    roomImage.addEventListener('click', function (e) {
      // Only handle this on mobile
      if (window.innerWidth < 768) {
        closeAllMobileTooltips();
      }
    });

    // Also add click handler to the visualization container (in case the click is between hotspots)
    visualization.addEventListener('click', function (e) {
      // Only handle this on mobile and if not clicking on a hotspot
      if (window.innerWidth < 768 && !e.target.closest('.product-hotspots__hotspot')) {
        closeAllMobileTooltips();
      }
    });

    // Initialize with the first hotspot's information for desktop
    if (hotspots.length > 0 && window.innerWidth >= 768) {
      updateProductInfo(hotspots[0]);
    }

    // Handle window resize
    window.addEventListener('resize', function () {
      const nowMobile = window.innerWidth < 768;

      // If we switched from desktop to mobile or vice versa
      if (!isMobile && nowMobile) {
        // Remove all active states when switching to mobile
        hotspots.forEach((h) => h.classList.remove('is-active'));
      } else if (isMobile && !nowMobile) {
        // When switching to desktop, activate the first hotspot
        if (hotspots.length > 0) {
          updateProductInfo(hotspots[0]);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          // animations.js sets opacity:0 on all .product-card at page load.
          // Injected cards are never picked up by that initial query, so reset manually.
          productRecommendationsSection.querySelectorAll('.product-card').forEach(card => {
            card.style.opacity = '1';
          });

          // Re-init wishlist buttons for dynamically injected cards
          if (typeof initButtons === 'function') initButtons();
          if (typeof wishlistManager !== 'undefined') wishlistManager.initButtons();

          const carousel = document.querySelector('.carousel');
          const progressBar = document.querySelector('.progress-bar');
          const progressFill = document.querySelector('.progress-fill');

          let isInteracting = false;

          function updateProgress(percentage) {
            // Ensure percentage is between 0 and 1
            percentage = Math.max(0, Math.min(percentage, 1));

            const maxScroll = carousel.scrollWidth - carousel.clientWidth;
            carousel.scrollLeft = maxScroll * percentage;

            const progressBarWidth = progressBar.offsetWidth;
            const progressFillWidth = progressFill.offsetWidth;
            const maxTranslate = progressBarWidth - progressFillWidth;
            const translateX = maxTranslate * percentage;
            progressFill.style.transform = `translateX(${translateX}px)`;
          }

          function handleMove(clientX) {
            const rect = progressBar.getBoundingClientRect();
            const percentage = (clientX - rect.left) / rect.width;
            updateProgress(percentage);
          }

          // Mouse events
          progressBar.addEventListener('mousedown', (e) => {
            isInteracting = true;
            handleMove(e.clientX);
            document.addEventListener('mousemove', handleMouseMove);
          });

          function handleMouseMove(e) {
            if (!isInteracting) return;
            handleMove(e.clientX);
          }

          document.addEventListener('mouseup', () => {
            if (isInteracting) {
              isInteracting = false;
              document.removeEventListener('mousemove', handleMouseMove);
            }
          });

          // Touch events
          progressBar.addEventListener('touchstart', (e) => {
            isInteracting = true;
            handleMove(e.touches[0].clientX);
            e.preventDefault(); // Prevent scrolling while touching progress bar
          });

          progressBar.addEventListener('touchmove', (e) => {
            if (!isInteracting) return;
            handleMove(e.touches[0].clientX);
            e.preventDefault();
          });

          progressBar.addEventListener('touchend', () => {
            isInteracting = false;
          });

          progressBar.addEventListener('touchcancel', () => {
            isInteracting = false;
          });

          // Update progress bar when carousel scrolls naturally
          carousel.addEventListener('scroll', () => {
            if (!isInteracting) {
              const maxScroll = carousel.scrollWidth - carousel.clientWidth;
              const percentage = carousel.scrollLeft / maxScroll;
              const progressBarWidth = progressBar.offsetWidth;
              const progressFillWidth = progressFill.offsetWidth;
              const maxTranslate = progressBarWidth - progressFillWidth;
              progressFill.style.transform = `translateX(${maxTranslate * percentage}px)`;
            }
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-list"] && !Shopify.designMode) return;
  try {
    
  class UspList {
    constructor() {
      this.init();
    }

    init() {
      const uspItems = document.querySelectorAll('.usp-list__item');
      const uspParagraphs = document.querySelectorAll('.usp-list__paragraph');
      const defaultParagraph = document.querySelector('[data-usp-default]');
      const isMobile = window.innerWidth < 768;

      // Function to handle paragraph visibility
      const showParagraph = (key) => {
        uspParagraphs.forEach((p) => {
          p.classList.remove('usp-list__paragraph--active');
        });

        if (key) {
          const targetParagraph = document.querySelector(`[data-usp-key="${key}"]`);
          if (targetParagraph) {
            targetParagraph.classList.add('usp-list__paragraph--active');
          }
        } else if (defaultParagraph) {
          defaultParagraph.classList.add('usp-list__paragraph--active');
        }
      };

      // Add event listeners based on device type
      uspItems.forEach((item) => {
        if (isMobile) {
          // Use click/touch events on mobile
          item.addEventListener('click', (e) => {
            const key = item.dataset.uspKey;

            // If the item was already active, show default paragraph
            if (item.classList.contains('usp-list__item--active')) {
              uspItems.forEach((i) => i.classList.remove('usp-list__item--active'));
              showParagraph(null);
            } else {
              // Otherwise show this item's paragraph
              uspItems.forEach((i) => i.classList.remove('usp-list__item--active'));
              item.classList.add('usp-list__item--active');
              showParagraph(key);
            }
          });

          // Handle keyboard interaction for accessibility
          item.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              item.click();
            }
          });
        } else {
          // Use hover events on desktop/tablet
          item.addEventListener('mouseenter', () => {
            const key = item.dataset.uspKey;
            showParagraph(key);
          });

          item.addEventListener('mouseleave', () => {
            showParagraph(null);
          });
        }
      });

      // Handle window resize
      window.addEventListener('resize', () => {
        const newIsMobile = window.innerWidth < 768;

        // Only reload if the device type changed
        if (newIsMobile !== isMobile) {
          location.reload();
        }
      });
    }
  }

  // Initialize the UspList component when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', () => {
    new UspList();
  });

  } catch(e) { console.error(e); }
})();
})();
